import { ConnectedProps, connect } from "react-redux";
import { actions, slotSelector } from "reducers/slots";
import { NotificationStateType } from "reducers/types/notification";
import { SlotsFilterType } from "reducers/types/slots";
import { SlotsType } from "sagas/types/slots";
import { actions as notificationActions } from "reducers/notification";
import { AppDispatch, RootState } from "store";
import SlotsDetail from "./SlotsDetail";
import { SlotsDetailContainerPropsType } from "./types";
import { useTranslation } from "react-i18next";
import useBasicData from "hooks/useBasicData";
import { useEffect } from "react";

const SlotsDetailContainer = (
  props: SlotsDetailContainerPropsType & ConnectorProps
) => {
  const { t } = useTranslation();
  const { slotStatus, regions } = useBasicData(["regions", "slotStatus"]);
  const handleRefresh = () => {
    const { filters, filtersExtraSeeMore } = props;
    props.getSlots({
      ...filters,
      offset: 0,
      limit: filtersExtraSeeMore.offset,
    });
  };
  useEffect(() => {
    props.setCollapseTable(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBulkDelete = () => {
    props.showNotification({
      id: "notification-bulk-delete",
      level: "warning",
      title: t("slotDetail:bulkDeleteSlotTitle"),
      body: t("slotDetail:bulkDeleteSlotMessage"),
      onConfirmLabel: "global:deleteConfirmation",
      onCancelLabel: "global:cancel",
      onConfirm: () => props.deleteBulkSlots(props.slotsSelected),
    });
  };

  return (
    <SlotsDetail
      {...props}
      regions={regions}
      status={slotStatus}
      onRefresh={handleRefresh}
      handleBulkDelete={handleBulkDelete}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  anySlotSelected: slotSelector(state).slotsSelected.length > 0,
  showDetailModal: slotSelector(state).showDetailModal,
  showCreationModal: slotSelector(state).showCreationModal,
  filters: slotSelector(state).filters,
  slotsSelected: slotSelector(state).slotsSelected,
  filtersExtraSeeMore: slotSelector(state).filtersExtraSeeMore,
  slotsWithError: slotSelector(state).slotsWithError,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  toggleDetailModalVisibility: (show: boolean) => {
    dispatch(actions.toggleDetailModalVisibility(show));
  },
  toggleCreationModalVisibility: (show: boolean) => {
    dispatch(actions.toggleCreationModalVisibility(show));
  },
  getSlots: (params: SlotsFilterType) => {
    dispatch(actions.getSlotsRequest(params));
  },
  deleteBulkSlots: (body: SlotsType[]) => {
    dispatch(actions.deleteBulkSlotDetailRequest(body));
  },
  showNotification: (content: NotificationStateType) => {
    dispatch(notificationActions.showNotification(content));
  },
  clearSlotsWithError: () => {
    dispatch(actions.setErrorSlots([]));
  },
  setCollapseTable: (collapse: boolean) => {
    dispatch(actions.setCollapseTable(collapse));
  },
  exportSlots: (params: SlotsFilterType) => {
    dispatch(actions.exportSlotsRequest(params));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(SlotsDetailContainer);
